// extracted by mini-css-extract-plugin
export var centerText = "_5u-8";
export var container = "_5u-0";
export var doughnutContainer = "_5u-7";
export var legend = "_5u-a";
export var legendItemColorDisplay = "_5u-b";
export var legendItemLabel = "_5u-d";
export var legendItemValue = "_5u-c";
export var lg = "_5u-5";
export var maxWidth = "_5u-9";
export var md = "_5u-4";
export var responsive = "_5u-6";
export var sm = "_5u-3";
export var xs = "_5u-2";
export var xxs = "_5u-1";